var TYPE = "TOAST_CLOSED";
/** Checks if bus message is of a Toast type */
export var isToastClosedMessage = function isToastClosedMessage(m) {
  return (m === null || m === void 0 ? void 0 : m.type) === TYPE;
};

/** Used for the toast manager to indicate whether a toast has been  */
export var toastClosedMessage = function toastClosedMessage(toastId, method) {
  return {
    type: TYPE,
    payload: {
      id: toastId,
      method: method
    }
  };
};